import React, { useMemo, useState } from 'react';
import DynamicTable from '@components/dynamic-table/dynamic-table.tsx';
import createTableStore from '@store/table-store/table.store.ts';
import ViewControls from '@components/view-controls/view-controls.tsx';
import { ViewControlsEnum } from '@models/view-controls.model.ts';
import { LanguageEnum } from '@models/language.model.ts';
import { selectAllTableColumns } from '@ui-kit/select-all-table/components/columns/columns.tsx';
import { SortOrder } from '@models/table.model.ts';
import { useTranslation } from 'react-i18next';
import useProfileStore from '@store/profile-store/profile.store.ts';
import {
  getMockServices,
  mockDepartmentUnits
} from '@ui-kit/select-all-table/mock-services.ts';

const SelectAllTable: React.FC = () => {
  const tableStore = useMemo(() => createTableStore(), []);
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [language, setLanguage] = useState(LanguageEnum.English);
  const [view] = useState(ViewControlsEnum.List);
  const { selectedCurrency } = useProfileStore();
  const { t } = useTranslation();

  const handleSelectAll = () => {
    if (selectedRows.length === tableStore.getState().tableData.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(
        tableStore.getState().tableData.map((row: any) => row.id)
      );
    }
  };

  const handleSelectRow = (rowId: string) => {
    setSelectedRows((prev) => {
      const newSelectedRows = [...prev];
      const index = newSelectedRows.indexOf(rowId);

      if (index === -1) {
        newSelectedRows.push(rowId);
      } else {
        newSelectedRows.splice(index, 1);
      }

      return newSelectedRows;
    });
  };

  const handleEdit = () => {
    // demo only — no request
  };

  const handleDelete = () => {
    // demo only — no request
  };

  const handleAction = (action: { type: string; value?: string }) => {
    switch (action.type) {
      case ViewControlsEnum.View:
        break;
      case ViewControlsEnum.Delete:
        break;
      case ViewControlsEnum.ImportPlaylist:
        break;
      case ViewControlsEnum.SelectAll:
        break;
      case ViewControlsEnum.Search:
        break;
      case ViewControlsEnum.Language:
        setLanguage(action.value as LanguageEnum);
        break;
    }
  };

  const columns = selectAllTableColumns(
    handleEdit,
    handleDelete,
    handleSelectRow,
    handleSelectAll,
    selectedRows,
    selectedCurrency,
    language,
    mockDepartmentUnits,
    t,
    tableStore.getState().tableData
  );

  return (
    <div className="w-full h-full">
      {view === ViewControlsEnum.List && (
        <div>
          <ViewControls onAction={handleAction} selectedRows={selectedRows} />

          <div className="mt-4 h-full max-h-[calc(100vh-268px)] max-lg-xl:max-h-[calc(100vh-248px)]">
            <DynamicTable
              tableStore={tableStore}
              apiFunction={getMockServices}
              // onTriggerAction={handleTableTrigger}
              columns={columns}
              language={language}
              tableKey="ui-kit-table"
              initialState={{
                sort: ['createdAt', SortOrder.Descending]
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectAllTable;
